import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

export default {
  props: {
    MuiButton: {
      disableRipple: true,
      disableFocusRipple: true,
      disableTouchRipple: true,
      disableElevation: true,
    },
    MuiButtonBase: {
      disableRipple: true,
      disableTouchRipple: true,
    },
    MuiIconButton: {
      disableRipple: true,
      disableFocusRipple: true,
    },
    MuiTab: {
      disableRipple: true,
      disableFocusRipple: true,
      disableTouchRipple: true,
    },
    MuiTableSortLabel: {
      IconComponent: ArrowDropDownIcon,
    },
    MuiWithWidth: {
      // Initial width property
      initialWidth: "lg", // Breakpoint being globally set 🌎!
    },
    MuiAppBar: {
      elevation: 0,
    },
    MuiPaper: {
      elevation: 0,
    },
    MuiTextField: {
      fullWidth: true,
      variant: "outlined",
    },
  },
};
